var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { z } from 'zod';
import { buildCsvValidator, } from './streamCsvValidation';
export var buildZodCsvValidator = function (zodSchema, options) {
    var rawSchema = zodSchema instanceof z.ZodObject
        ? Object.entries(zodSchema.shape).reduce(function (headerZodSchema, _a) {
            var header = _a[0], zodStrSchema = _a[1];
            headerZodSchema[header] = function (val) {
                zodStrSchema.parse(val);
            };
            return headerZodSchema;
        }, {})
        : zodSchema.items.map(function (zodStrSchema) { return function (val) {
            zodStrSchema.parse(val);
        }; });
    return buildCsvValidator(rawSchema, __assign(__assign({}, options), { errorExtractor: function (err) {
            if (err instanceof z.ZodError) {
                return err.issues.map(function (_a) {
                    var message = _a.message;
                    return message;
                });
            }
            return ['Unknown'];
        } }));
};
//# sourceMappingURL=buildZodCsvValidator.js.map